import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

export const accessFailureLogEntityAdapter: EntityAdapter = {
  entity: "accessfailurelog",
  defaultSort: { sort: "-attempt_time", tableSort: "attempt_time", descending: true },
};
